/* Continue Reading Button for Category Descriptions */
(function(){
  
  let cutTextContent = function(textContentSelector){
    let maximumWordCount = 88
	let element = document.querySelector(textContentSelector);
    if(typeof element === 'undefined' || element === null){
      return;
    }
	let words = [];
	element.innerHTML.replace(/<[^<>]+>|(?:\S(?![^<>]+>))+|\s+/ig, function($0){
		words.push($0);
	});
	
	function create(html) {
	  const template = document.createElement('template');
	  template.innerHTML = html.trim();
	  return template.content.children;
    }

	let content = element.innerHTML;
	let shortContent = null;
	if(words.length > maximumWordCount){
		let tagsNeedsClosing = {}
		let selectedWords = words.slice(0, maximumWordCount).map(word => {
			if(/^<br\s*\/?>$/i.test(word)){
				return ' ';
			}
			if(/\s+/ig.test(word))
				return ' ';
			if(/^<([^<>]+)>$/i.test(word)){
				let tag = null;
				word.replace(/^<([^<>]+)>$/i, function($0, $1){
					tag = $1;
				});
				if(tag.indexOf('/') === 0){
					tag = tag.substring(1);
					if(typeof tagsNeedsClosing[tag] !== 'undefined'){
						tagsNeedsClosing[tag] -= 1;
					}else{
						return '';
					}
				}else{
					if(typeof tagsNeedsClosing[tag] === 'undefined'){
						tagsNeedsClosing[tag] = 1;
					}else{
						tagsNeedsClosing[tag] += 1;
					}
				}
			}
			return word;
		});
		shortContent = selectedWords.join(''); 
		Object.keys(tagsNeedsClosing).forEach(x => {
			while(tagsNeedsClosing[x] > 0){
				shortContent += '</' + x + '>';
				tagsNeedsClosing[x] -= 1;
			}
		});
		
		shortContent = shortContent; 
	}

    function makeShorter(){
        element.innerHTML = shortContent;
		
		let link = create("<a style='margin-left: 1em; display: inline-block; cursor: pointer;'>Lees meer</a>");
		link = link[0];
		link.onclick = function(){
			makeLonger();
		};
        let container = element;
        if(element.children.length > 0){
          container = element.children[element.children.length - 1];
        }
        container.append(create('<span>...</span>')[0]);
        container.append(link);
    };

    function makeLonger(){
      
        element.innerHTML = content;
		
		let link = create("<a style='margin-left: 1em; display: inline-block; cursor: pointer;'>Lees minder</a>");
		link = link[0];
		link.onclick = function(){
			makeShorter();
		};
        let container = element;
        if(element.children.length > 0){
          container = element.children[element.children.length - 1];
          if(container.tagName === 'BR'){
            container = element;
          }
        }
        container.append(link);
    };
	
	if(shortContent !== null){
		makeShorter();        
	}
    
  };

  cutTextContent("#main .shopify-section.shopify-section--collection-banner .prose");
  cutTextContent("#main .product-info__accordion .accordion__content .prose");
 
})();

/* Filter Tags - Custom Order */
(function(){

  let customOrder = [
    "UTR",
    "E-fatbikes",
    "F - Line",
    "R - Line",
    "S - Line",
    "Black Panther",
    "Ouxi"
  ];
  
  document.querySelectorAll("#accordion-filter-p-tag").forEach(el => {
    let tagsByValue = {};
    let tags = el.querySelectorAll(".checkbox-list .checkbox-container");
    tags.forEach(tagElement => {
      tagElement.remove();
      let value = tagElement.querySelector("input").value;
      tagsByValue[value] = tagElement;
    });
    
    customOrder.forEach(field => {
      if(typeof tagsByValue[field] !== 'undefined'){
        el.querySelector(".checkbox-list").append(tagsByValue[field]);
        delete tagsByValue[field];
      }
    });

    Object.values(tagsByValue).forEach(tagElement => {
        el.querySelector(".checkbox-list").append(tagElement);
    });
  });
  
})();

/* Article Key Points */
(function(){

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function(){

    let headingElements = document.querySelectorAll(".page > .prose h4");
    headingElements.forEach(function(element, index){
    });
    
  });
  
})();

/* Expand Product Description */
(function(){
  let element = document.querySelector(".product-info__accordion");
    if(typeof element === 'undefined' || element === null){
      return;
    }
  element.setAttribute("open", true); 
  element.querySelector(".accordion__content").style.opacity = '1';
})();

/* Tooltips for Service Pack Options */
(function(){
  function generateElements(html) {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return Array.from(template.content.children);
  }

  function generateTooltip(content){
    return generateElements("<label class=\"gpo-label\" style=\"display: inline-flex;margin: 0 !important;vertical-align: text-bottom;\">"+
        "<span class=\"label-tooltip\">"+
        "<svg class=\"label-tooltip__icon\" xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">"+
        "  <path d=\"M12 24c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12zm1-6h-2v-8h2v8zm-1-12.25c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z\"></path>"+
        "</svg>"+
        "<span class=\"label-tooltip__content\" style=\"width: auto;\">" + content + "</span>"+
        "</span>"+
        "</label>");
  }
  
  let c = setInterval(function(){
    let element = document.querySelector("[gpo-data-product-handle=\"option-set-255305-radio-6\"]");
    if(typeof element === 'undefined' || element === null){
      return;
    }else{
      element = document.querySelector("#radio-6_1[gpo-data-product-handle=\"option-set-255305-radio-6\"]");
      generateTooltip("1x onderhoudsbeurt").forEach(function(x){
        element.parentNode.append(x);
      });
      element = document.querySelector("#radio-6_2[gpo-data-product-handle=\"option-set-255305-radio-6\"]");
      generateTooltip("3x onderhoudsbeurt").forEach(function(x){
        element.parentNode.append(x);
      });
      element = document.querySelector("#radio-6_3[gpo-data-product-handle=\"option-set-255305-radio-6\"]");
      generateTooltip("5x onderhoudsbeurt").forEach(function(x){
        element.parentNode.append(x);
      });
      
      clearInterval(c);
    }
  },333);
})();

/* Delivery Date Status - Placeholders */
(function(){
  let lastSignature = '';
  setInterval(function(){
    let deliveryDateInfoElements = Array.from(document.querySelectorAll("[delivery-date-status]"));

    let signature = '';
    deliveryDateInfoElements.forEach(function(element){
      signature += element.getAttribute("delivery-date-status").toString();
    });

    if(signature !== lastSignature){
      deliveryDateInfoElements.forEach(function(infoElement){
        let textElement = infoElement.querySelector("span");
        let text = textElement.innerText.trim();
        let regexp = /\{\{\s*([a-zA-Z][a-zA-Z0-9-_]+)\s*\}\}/ig;
        text = text.replace(regexp, function($0, $1){
          let placeholder = $1.toLowerCase();
          if(placeholder === 'tomorrow'){
            let tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            return (new Intl.DateTimeFormat("nl-NL", {weekday: "long"})).format(tomorrow);
          }
          return $0;
        });
        textElement.innerText = text;
      });
      
      lastSignature = signature;
    }
  }, 50);
})();